import { CalendarCheckIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import { labelForToken } from 'app/lib/workflows/dataContext'
import { humanizeTokens } from 'app/lib/workflows/messageFallbacks'
import type { LogFollowUpFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Logs a follow-up on the enrolled contact, as the contact's Follow Up action does. */
export function LogFollowUpNode({ data, selected }: NodeProps<LogFollowUpFlowNode>) {
  const copy = useListCopy()
  return (
    <NodeShell
      icon={CalendarCheckIcon}
      accent="amber"
      kind="Log a follow-up"
      label={data.label}
      description={data.note.trim() ? humanizeTokens(data.note, (token) => labelForToken(token, copy)) : `No note`}
      selected={selected}
    />
  )
}
